import cn from "classnames";
import React from "react";

interface ReportDataControlsProps {
    demoData: boolean;
    onDemoChange: (demo: boolean) => void;
}

/** Shared company/demo switch; each page owns its additional report actions. */
export default function ReportDataControls({ demoData, onDemoChange }: ReportDataControlsProps) {
    return (
        <div className="btn-group ml-3" role="group" aria-label="Данные отчёта">
            <button
                type="button"
                aria-pressed={demoData}
                className={cn("btn btn-xs", { "btn-dark": demoData, "btn-secondary": !demoData })}
                onClick={() => onDemoChange(true)}
            >
                Демо данные
            </button>
            <button
                type="button"
                aria-pressed={!demoData}
                className={cn("btn btn-xs", { "btn-dark": !demoData, "btn-secondary": demoData })}
                onClick={() => onDemoChange(false)}
            >
                Данные компании
            </button>
        </div>
    );
}
